import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import LegacySelect from 'react-select-legacy';
import { useTranslation } from 'react-i18next';
import { isAdminDashboard } from 'utils/authScopes';
import DateRange from '../../components/filters/DateRange';
import { groupByDisabled } from 'utils/select';

const DashboardFilter = ({
  auth,
  meta,
  ages,
  onAgeChange,
  cohorts,
  onCohortChange,
  groups,
  onGroupChange,
  subgroups,
  onSubgroupChange,
  partners,
  onPartnerChange,
  periods,
  onPeriodChange,
  isLoading,
}) => {
  const { t } = useTranslation();
  return (
    <div className='row u-margin-top--large u-margin-bottom--base'>
      {isAdminDashboard(auth) &&
        <div className='column small-12 medium-3 large-3 u-margin-bottom--base'>
          <LegacySelect
            name='sp-partner-select'
            className={'o-select o-select--optgroup'}
            multi={true}
            value={meta.partners || ''}
            onChange={onPartnerChange}
            options={partners}
            placeholder={t('filters.allPartners')}
            simpleValue={true}
            disabled={isLoading}
          />
        </div>}
      {groups.length > 1 &&
        <div className='column small-12 medium-3 large-3 u-margin-bottom--base'>
          <Select
            name='sp-group-select'
            className={'o-select o-select--optgroup'}
            isMulti
            value={groups.filter(v => (meta.groups || '').split(',').map(i => parseInt(i)).includes(v.value))}
            onChange={(v) => onGroupChange(v.map(i => i.value).join(','))}
            options={groups}
            placeholder={t('filters.allGroups')}
            isDisabled={isLoading}
          />
        </div>
      }
      {subgroups.length > 1 &&
        <div className='column small-12 medium-3 large-3 u-margin-bottom--base'>
          <Select
            name='sp-cohort-select'
            className={'o-select o-select--optgroup'}
            isMulti
            value={subgroups.filter(v => (meta.subgroups || '').split(',').map(i => parseInt(i)).includes(v.value))}
            onChange={(v) => onSubgroupChange(v.map(i => i.value).join(','))}
            options={groupByDisabled(subgroups)}
            placeholder={t('filters.allSubgroups')}
            isDisabled={isLoading}
          />
        </div>
      }
      {cohorts.length > 1 &&
        <div className='column small-12 medium-3 large-3 u-margin-bottom--base'>
          <Select
            name='sp-cohort-select'
            className={'o-select o-select--optgroup'}
            isMulti
            value={cohorts.filter(v => (meta.cohorts || '').split(',').map(i => parseInt(i)).includes(v.value))}
            onChange={(v) => onCohortChange(v.map(i => i.value).join(','))}
            options={groupByDisabled(cohorts)}
            placeholder={t('filters.allCohorts')}
            isDisabled={isLoading}
          />
        </div>
      }
      <div className='column small-12 medium-3 large-3 u-margin-bottom--base'>
        <LegacySelect
          name='sp-age-select'
          className={'o-select'}
          multi={true}
          value={meta.ages || ''}
          onChange={onAgeChange}
          options={ages}
          placeholder={t('filters.ageRange')}
          simpleValue={true}
          disabled={isLoading}
        />
      </div>
      <div className='column small-12 u--margin-bottom'>
        <DateRange
          startDate={meta.start}
          endDate={meta.end}
          onDatesChange={onPeriodChange}
          periods={periods}
          disabled={isLoading}
        />
      </div>
    </div>
  );
}

DashboardFilter.propTypes = {
  auth: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  ages: PropTypes.arrayOf(PropTypes.object).isRequired,
  cohorts: PropTypes.arrayOf(PropTypes.object).isRequired,
  subgroups: PropTypes.arrayOf(PropTypes.object).isRequired,
  groups: PropTypes.arrayOf(PropTypes.object).isRequired,
  partners: PropTypes.arrayOf(PropTypes.object).isRequired,
  periods: PropTypes.arrayOf(PropTypes.object).isRequired,
  withScope: PropTypes.object.isRequired,
  onAgeChange: PropTypes.func.isRequired,
  onCohortChange: PropTypes.func.isRequired,
  onSubgroupChange: PropTypes.func.isRequired,
  onGroupChange: PropTypes.func.isRequired,
  onPartnerChange: PropTypes.func.isRequired,
  onPeriodChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
}

export default DashboardFilter;
